import React, { useEffect, useState } from "react";
import "./reviewspage.css";
import Header from "../features/Header";
import api from "../api/axios";

const ReviewsPage = () => {
  const [reviews, setReviews] = useState([]);
  const [cars, setCars] = useState([]);

  const [dialogOpen, setDialogOpen] = useState(false);
  const [newName, setNewName] = useState("");
  const [newMessage, setNewMessage] = useState("");
  const [newCarId, setNewCarId] = useState("");
  const [newRating, setNewRating] = useState("");

  const handleAddReview = () => {

    if(newName === "" || newMessage === "" || newRating === "" || newCarId === "")
    {
      setDialogOpen(false);
      return;
    }

    const selectedCar = cars.find(
      (car) => Number(car.CarID) === Number(newCarId)
    );

    console.log(selectedCar, newCarId, selectedCar);

    if (Number(newRating) > 5 || Number(newRating) < 1) {
      setNewRating(5);
    }

    const newReview = {
      id: Date.now(),
      name: newName || "Анонім",
      message: newMessage,
      carId: newCarId,
      car: selectedCar ? selectedCar.FullName : "Не вказано",
      rating: newRating,
      date: new Date().toLocaleDateString(),
    };

    setReviews([newReview, ...reviews]);
    setDialogOpen(false);

    try {
      api
        .post(
          "/api/v1/addReview",
          JSON.stringify({
            name: newName,
            message: newMessage,
            carId: newCarId,
            rating: newRating,
          }),
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          console.log("Успіх:", response.data);
        })
        .catch((error) => {
          console.error("Помилка при відправці відгуку:", error);
        });
    } catch (err) {
      throw err;
    }

    setNewName("");
    setNewMessage("");
    setNewCarId("");
    setNewRating("");
  };

  useEffect(() => {
    const fetchReviews = async () => {
      try {
        const response = await api.get("/api/v1/getReviews");
        const serverReviews = response.data.reviews;

        const formattedReviews = serverReviews.map((review) => ({
          id: review.ID,
          name: review.author,
          message: review.comment,
          car: review.FullName,
          date: new Date(review.Date).toLocaleDateString(),
          rating: review.rating,
        }));

        setReviews(formattedReviews);
      } catch (error) {
        console.error("Помилка при завантаженні відгуків:", error);
      }
    };

    const fetchCars = async () => {
      try {
        const response = await api.get("/api/v1/carInfo");
        setCars(response.data.cars);
      } catch (error) {
        console.error("Помилка при завантаженні моделей машин:", error);
      }
    };

    fetchReviews();
    fetchCars();
  }, []);

  return (
    <>
      <Header />
      <div className="reviews-container">
        <div className="reviews-header">
          <h1>Відгуки</h1>
          <button
            className="add-review-btn"
            onClick={() => setDialogOpen(true)}
          >
            Залишити відгук
          </button>
        </div>

        <div className="review-list">
          {reviews.map((review) => (
            <div className="review-card" key={review.id}>
              <h3 className="review-author">{review.name}</h3>
              <p className="review-car">Автомобіль: {review.car}</p>
              <p className="review-date">Дата: {review.date}</p>
              <p className="review-rating">Оцінка: {review.rating ?? "—"}/5</p>
              <p className="review-message">"{review.message}"</p>
            </div>
          ))}
        </div>
      </div>

      {dialogOpen && (
        <div className="dialog-backdrop">
          <div className="dialog">
            <button className="close-btn" onClick={() => setDialogOpen(false)}>
              ×
            </button>
            <h2>Новий відгук</h2>
            <input
              type="text"
              placeholder="Ваше ім'я"
              value={newName}
              onChange={(e) => setNewName(e.target.value)}
              className="modal-input"
              required={true}
            />
            <select
              value={newCarId}
              onChange={(e) => setNewCarId(e.target.value)}
              className="modal-input"
            >
              <option value="">Виберіть модель</option>
              {cars.map((car) => (
                <option key={car.CarID} value={car.CarID}>
                  {car.FullName}
                </option>
              ))}
            </select>
            <textarea
              placeholder="Ваш відгук"
              value={newMessage}
              onChange={(e) => setNewMessage(e.target.value)}
              className="modal-textarea"
            />
            <input
              type="text"
              placeholder="Оцінка (1-5)"
              value={newRating}
              onChange={(e) => {
                const val = e.target.value;
                // Дозволяємо тільки 1, 2, 3, 4, 5
                if (/^[1-5]?$/.test(val)) {
                  setNewRating(val);
                }
              }}
              className="modal-input"
            />

            <div className="dialog-footer">
              <button onClick={handleAddReview}>Відправити</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ReviewsPage;
